import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-top: 4rem;
`;

type Props = {
  children?: React.ReactNode
};

export const PageFooter: React.FC<Props> = (props) => (
  <Container>{props.children}</Container>
);
